import { styled } from '@material-ui/core/styles'

import { imageSectionMobileHeightPx } from 'artkive/pages/Pricing/ImageTextSection'
import { BREAKPOINTS } from 'artkive/utils/constants'

export const ImageBox = styled('div')(({ theme }) => ({
  height: '100%',
  position: 'relative',
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    height: `${imageSectionMobileHeightPx}px`,
    '& img': {
      marginTop: '8px',
    },
  },
}))

export const StorageBadgeImage = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: -36,
  [theme.breakpoints.down(BREAKPOINTS.lg)]: {
    width: 133,
    height: 133,
    top: '10%',
    right: -40,
  },
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    width: 113,
    height: 113,
    top: 8,
    right: -72,
  },
}))
